"use client";

interface Citation {
  reviewId: number;
  text: string;
  relevanceScore: number;
}

interface AiReviewSummaryData {
  institutionName?: string;
  summary?: string;
  commonTags?: {
    strengths?: string[];
    concerns?: string[];
    sentimentScore?: number;
  };
  tagSummaries?: Record<string, string>;
  citations?: Citation[];
}

interface AiSummarizedReviewContentsProps {
  aiReviewSummary: AiReviewSummaryData;
}

const AiSummarizedReviewContents = ({
  aiReviewSummary,
}: AiSummarizedReviewContentsProps) => {
  if (!aiReviewSummary?.summary) return null;

  return (
    <div className="w-full inline-flex flex-col justify-start items-start gap-2">
      <div className="text-[#333333] font-inter font-semibold text-[18px] leading-[27px]">Summary</div>

      <div className="flex flex-col gap-[8px]">
        <div className="self-stretch justify-start text-grey300 text-base font-normal font-inter">
          {aiReviewSummary.summary}
        </div>

        <div className="inline-flex justify-start items-center gap-1">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 1V5M1 3H5M4 15V19M2 17H6M11 1L13.2857 7.85714L19 10L13.2857 12.1429L11 19L8.71429 12.1429L3 10L8.71429 7.85714L11 1Z" stroke="#767676" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <div className="justify-start text-neutral-500 text-sm font-medium font-inter">
            Generated from the text of student reviews
          </div>
        </div>
      </div>
    </div>
  );
};

export default AiSummarizedReviewContents;
